var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.filterCriteria || !_vm.filterCriteria.length
        ? _c(
            "div",
            [
              _vm._l(_vm.quickFilters, function(quickFilter, idx) {
                return _c("PresetFilter", {
                  key: quickFilter.field,
                  attrs: {
                    last: idx === _vm.quickFilters.length,
                    filter: quickFilter.displayName
                  },
                  on: {
                    click: function($event) {
                      return _vm.addANDRule(
                        0,
                        quickFilter.tagId,
                        quickFilter.field
                      )
                    }
                  }
                })
              }),
              _vm._v(" "),
              _c(
                "btn",
                {
                  staticClass: "m-b-10",
                  attrs: {
                    type: "primary",
                    size: "sm",
                    title: "Click to add filter"
                  },
                  on: {
                    click: function($event) {
                      return _vm.addORRule()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v("\n      " + _vm._s(_vm.$t("FILTER_TEXT")) + "\n    ")
                ]
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.filterCriteria, function(andCriteria, andIndex) {
        return _c(
          "div",
          {
            key: andCriteria.key,
            staticClass: "filter-item filter-item-and-condition slide-down"
          },
          [
            _c("AndCriteria", {
              attrs: {
                "and-criteria": andCriteria.tagCriteria,
                "and-index": andIndex,
                "is-read-only": _vm.isReadOnly,
                "is-full-width": _vm.isFullWidth,
                "is-summary-view": _vm.isSummaryView,
                "available-tags": _vm.availableTags,
                "form-name-for-user-settings": _vm.formNameForUserSettings,
                "use-in-reporting-filters": _vm.useInReportingFilters,
                "values-for-reporting-filter": _vm.valuesForReportingFilter,
                "event-category": _vm.eventCategory
              },
              on: {
                change: (andCriteria, andIndex) =>
                  _vm.handleAndChange(andCriteria, andIndex),
                addORRule: _vm.addORRule,
                addANDRule: _vm.addANDRule
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }